import React from 'react';
import {
  StyledCard,
  StyledCardActionArea,
  StyledContent,
  StyledHeader,
  StyledCardMedia,
  StyledMenu,
  StyledTitle,
} from './styles';
import { Behavior } from '@prisjakt/ui/text';
import { Axis } from '@prisjakt/ui';
import { Clickable } from 'src/components/clickable';
import { ProductMedia } from '../product-card-new/components/media';

type MiniCardProps = {
  image?: string | React.ReactNode | null;
  title?: string;
  children?: React.ReactNode;
  menu?: React.ReactNode;
  to?: string;
  onClick?: () => void;
};

export const MiniCard: React.FC<MiniCardProps> = props => {
  return (
    <StyledCard direction={Axis.X}>
      {props.menu && <StyledMenu>{props.menu}</StyledMenu>}
      <StyledCardActionArea
        container={props.to ? Clickable : 'div'}
        containerProps={{ to: props.to, onClick: props.onClick }}
      >
        {props.image && (
          <StyledCardMedia $flex="1 0 auto">
            {typeof props.image === 'string' ? (
              <ProductMedia
                lazyLoadImage
                imageSize={72}
                imageSrc={props.image}
                name={props.title ?? ''}
              />
            ) : (
              props.image
            )}
          </StyledCardMedia>
        )}
        <StyledContent>
          {props.title ? (
            <StyledHeader>
              <StyledTitle behavior={Behavior.TwolineEllipsis}>
                {props.title}
              </StyledTitle>
            </StyledHeader>
          ) : (
            undefined
          )}
          {props.children}
        </StyledContent>
      </StyledCardActionArea>
    </StyledCard>
  );
};
